/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Viewer_Ex_NoteInputs */

const en_viewer_ex_note = /** @type {(inputs: Viewer_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Strip the leading root and each path is a valid JavaScript accessor. Note that zip is a string, so its leading zero is intact, while score is a number.`)
};

const ko_viewer_ex_note = /** @type {(inputs: Viewer_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`앞의 root를 떼면 각 경로가 유효한 자바스크립트 접근자입니다. zip은 문자열이라 앞의 0이 온전하고 score는 숫자라는 점에 주의하세요.`)
};

const ja_viewer_ex_note = /** @type {(inputs: Viewer_Ex_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先頭の root を落とせば各パスは妥当な JavaScript のアクセサです。zip は文字列なので先頭のゼロが残り、score は数値であることに注意してください。`)
};

/**
* | output |
* | --- |
* | "Strip the leading root and each path is a valid JavaScript accessor. Note that zip is a string, so its leading zero is intact, while score is a number." |
*
* @param {Viewer_Ex_NoteInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const viewer_ex_note = /** @type {((inputs?: Viewer_Ex_NoteInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Viewer_Ex_NoteInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_viewer_ex_note(inputs)
	if (locale === "ko") return ko_viewer_ex_note(inputs)
	return ja_viewer_ex_note(inputs)
});